import { CultureInfo } from '../culture-info.model';
import { CultureInfoPt } from './pt';

/**
 * @ignore
 */
export const CultureInfoPtGQ: CultureInfo = {
  name: 'pt-GQ',
  displayName: 'português (Guiné Equatorial)',
  iso3LanguageCode: 'por',
  iso2LanguageCode: 'pt',
  ietfLanguageTag: 'pt-GQ',
  parent: CultureInfoPt
};
